import { useEffect, useState } from 'react';
import { ActionIcon, useMantineColorScheme, useComputedColorScheme, Group, TextInput, Button } from '@mantine/core';
import { IconSun, IconMoon } from '@tabler/icons-react';
import { showNotification } from '@mantine/notifications';
import { useUser } from './Context';
import { get } from './Request';

export default function AppFooter() {
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme('light', { getInitialValueInEffect: true });
  const [token, setToken] = useState('');
  const [cachedToken, setCachedToken] = useState('');
  const [inputError, setInputError] = useState(false);
  const { refreshPage, setRefresh } = useUser();

  useEffect(() => {
    const savedToken = localStorage.getItem('userToken');
    if (savedToken) {
      setToken(savedToken);
      setCachedToken(savedToken);
    }
  }, []);

  const handleSaveToken = async () => {
    if (token !== cachedToken) {
      try {
        const response = await get('checkToken', null, token);
        if (response.exists) {
          localStorage.setItem('userToken', token);
          localStorage.setItem('isAdmin', response.user.isAdmin);
          localStorage.setItem('isSuperAdmin', response.user.isSuperAdmin);
          localStorage.setItem('groupId', response.user.groupId);
          localStorage.setItem('groupName', response.user.groupName);
          setRefresh(true);
          setCachedToken(token);
          showNotification({
            title: 'Succès',
            message: `Token valide`,
            color: 'green',
            autoClose: 3000
          });
          setInputError(false);
        } else {
          setInputError(true);
          setRefresh(true);

          showNotification({
            title: 'Erreur',
            message: `Token invalide`,
            color: 'red',
            autoClose: 3000
          });
          localStorage.setItem('userToken', token);
          localStorage.setItem('isAdmin', false);
          localStorage.setItem('isSuperAdmin', false);
          localStorage.setItem('groupId', null);
          localStorage.setItem('groupName', null);
          setCachedToken(token);
        }
      } catch (error) {
        localStorage.setItem('userToken', token);
        setRefresh(true);

        localStorage.setItem('isAdmin', false);
        localStorage.setItem('isSuperAdmin', false);
        localStorage.setItem('groupId', null);
        localStorage.setItem('groupName', null);
        setCachedToken(token);
        showNotification({
          title: 'Erreur',
          message: `Token invalide`,
          color: 'red',
          autoClose: 3000
        });
        console.error('Error checking token:', error);
        setInputError(true);
      }
    }
    refreshPage(true);
  };

  return (
    <>
      <Group justify="space-between" style={{ flex: 1 }}>
        <Group>
          <TextInput placeholder="TOKEN" value={token} onChange={(e) => setToken(e.target.value)} error={inputError ? true : false} />
          <Button onClick={handleSaveToken} disabled={token === cachedToken}>
            Sauvegarder
          </Button>
          <ActionIcon onClick={() => setColorScheme(computedColorScheme === 'light' ? 'dark' : 'light')} variant="default" size="md" aria-label="Toggle color scheme">
            {computedColorScheme === 'dark' ? <IconSun stroke={1.5} /> : <IconMoon stroke={1.5} />}
          </ActionIcon>
        </Group>
      </Group>
    </>
  );
}
